import { z } from "zod/v4";

import { GaStream } from "../../../../../schemas/google";

export const GaGetPropertyAudiencesPathParamSchema = z.object({
  accountId: z.string(),
  propertyId: z.string(),
});

export type GaGetPropertyAudiencesPathParamType = z.infer<
  typeof GaGetPropertyAudiencesPathParamSchema
>;

export type GaGetPropertyAudiencesResponseType = {
  audiences: GaStream[];
};
